<template>
    <tr :class="`${isViewRequested ? 'edit-row' : ''}`">
        <td>
            <EmptyTextHandler :text="note.title" />
        </td>
        <td>
            <EmptyTextHandler :text="formatDate(note.date)" />
        </td>
        <td>
            <EmptyTextHandler :text="note.userName" />
        </td>
        <td class="text-end">
            <button
                type="button"
                class="btn table-btn btn-outline-info"
                @click="openViewNote()"
                v-if="!isViewRequested"
                v-tooltip="{ title: 'View Note' }"
            >
                <i class="fas fa-eye"></i>
            </button>
            <i v-if="isViewRequested">View In Progress</i>
        </td>
    </tr>
    <tr v-if="isViewRequested" class="edit-row">
        <td :colspan="columns">
            <PreadmissionNotesForm
                :is-read-only="true"
                :show-note-form="isViewRequested"
                :note="note"
                :patientDetails="patientDetails"
                :closeNoteFormProp="closeViewNote"
                :application="application"
            />
        </td>
    </tr>
</template>

<script src="./PreadmissionNotesRow.ts"></script>
